<template>
  <div>
    <a-card>
      <!-- 查询 -->
      <SearchView
        :renderItem="searchSchema"
        :formLayout="formLayout"
        :initialValues="searchData"
        @fetchSearch="handelSearch"
        :isExpandShowOrNot="false"
      ></SearchView>
    </a-card>
    <a-card style="margin-top:20px;">
      <!-- 结果 -->
      <TableView
        ref="table"
        :columns="columns"
        :pagination="pageData"
        :data="tableData"
        :scroll="scroll"
        @handlePagination="handlePagination"
      >
        <!--状态 slot-->
        <template v-slot:status="{ tableRow }">
          <span>
            <a
              href="javascript:void(0);"
              :color="'#1AA9EC'"
              @click="handelDetail(tableRow)"
            >
              评分明细
            </a>
          </span>
          <a-divider type="vertical" />
          <span>
            <a
              href="javascript:void(0);"
              :color="'#1AA9EC'"
              @click="handelReport(tableRow)"
            >
              评分报告
            </a>
          </span>
        </template>
      </TableView>
    </a-card>
  </div>
</template>

<script>
import { SearchView, TableView } from 'lxfintech-fe'
import mixin from './mixin'
import { getTableData } from './api'
// import { timestamp2date } from 'utils/util.js'
export default {
  mixins: [mixin],
  components: {
    SearchView,
    TableView,
  },
  data() {
    return {
      loading: '',
      scroll: { x: 800 }, //滚动设置
      formLayout: 'inline',
      tableData: [],
      pageData: {
        showTotal: total => `总共 ${total} 条`, //展示总条数
      },
      frozenText: '',
    }
  },
  mounted() {
    this._getTableData()
  },
  methods: {
    //获取table数据
    async _getTableData() {
      try {
        const pageData = { ...this.pageData }
        console.log(pageData)

        pageData.pageNum = pageData.current

        delete pageData.current

        const query = {
          ...this.searchData,
          ...pageData,
        }
        delete query.times

        const result = await getTableData(query)
        console.log(result.data)
        this.tableData = result.data.records
        this.pageData.total = result.data.total
      } catch (err) {
        console.log(err)
      }
    },
    //点击查询
    handelSearch(query) {
      console.log(query)
      this.searchData.name = query.name
      this.searchData.username = query.username
      this.searchData.status = query.status
      if (query.times && query.times[0]) {
        this.searchData.startDate = query.times[0]
        this.searchData.endDate = query.times[1]
      } else {
        this.searchData.startDate = ''
        this.searchData.startDate = ''
      }
      // if (query.startDate) {
      //   this.searchData.startDate = timestamp2date(
      //     query.startDate[0]['_d'].getTime()
      //   )
      //   this.searchData.endDate = timestamp2date(
      //     query.startDate[1]['_d'].getTime()
      //   )
      // }

      this._getTableData()
    },
    // 跳转百应前台页面
    handelReport({ id, tname }) {
      console.log({ id, tname })
      this.$router.push({
        path: '/saas/sass-score-detail',
        query: { id, tname },
      })
    },
    //跳转详情页
    async handelDetail(row) {
      const { id } = row
      // this.SET_COMPANY({ name, code })
      // this.$router.push({ name: 'user-score-details', params: { id: id } })
      this.$router.push({ path: '/saas/user-score-details', query: { id } })
      // })
      // const {
      //   data: { permissions }
      // } = await getCustomerOverview(id)
      // this.permissions = permissions
      // this.SET_PERMISSIONS(this.permissionsObj())
    },
    //分页W
    handlePagination(pagination) {
      ;({
        current: this.pageData.current,
        pageSize: this.pageData.pageSize,
        total: this.pageData.total,
      } = pagination)

      this._getTableData()
    },
  },
}
</script>
<style lang="less" scoped>
#components-a-tooltip-demo-placement .ant-btn {
  width: 70px;
  text-align: center;
  padding: 0;
  margin-right: 8px;
  margin-bottom: 8px;
}
</style>
